import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setStep } from '../../reducers/step';
import store from '../../store';
import _ from 'lodash';
import { getQueryVariable } from '../../utils/location';
import { updateSubscription } from '../../reducers/subscription';

const rightStep = () => {
  let steps = store.getState().steps;
  let step = steps[1];

  _.forOwn(steps, function(value) {
    if(!value.complete){
      step = value;
      return false;
    }
  });

  return step;
}

const Step = ({ Component, step, history }) => {
  const dispatch = useDispatch();
  const steps = useSelector((state) => state.steps);

  const verifyCoffee = () => {
    const coffeeId = getQueryVariable('coffee');
  
    if(coffeeId){
      const coffees = {};
      coffees[coffeeId] = 1;
  
      dispatch(updateSubscription({
        planPage: 'customize',
        coffees: coffees,
        orderType: 1,
        quantity: 1
      }));
    }
  }

  useEffect(() => {
    dispatch(setStep(step));

    if(steps[parseInt(step) - 1] && !steps[parseInt(step) - 1].complete){
      history.push(rightStep().path);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    verifyCoffee();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Component />
  )
}

export default withRouter(Step);
